export const listAccountApplications = `
   query listAccountApplications($filter:AccountApplicationsFilterInput) {
       listAccountApplications(filter:$filter) {
           items {
              id
              accountId
              account {
                  id
                  username
              }
              applicationId
              application {
                  id 
                  name
                  url
                  logoUrl
              }
              accountApplicationStatus
              created
              updated
           }
           nextToken
       }
   }
`;


export const getAccountApplication = `
   query getAccountApplication($id:ID!) {
       getAccountApplication(id:$id) {
         id
         accountId
         applicationId
         application {
             id 
             name
         }
         accountApplicationStatus
         created
         updated
       } 
}`;
